"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.audioComplete = void 0;
var util_1 = require("./util");
var audioComplete = function (event) {
    return (0, util_1.audioEvent)(event, "audio-complete");
};
exports.audioComplete = audioComplete;
